import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent, MatPaginatorModule } from '@angular/material/paginator';
import { Sort, MatSortModule } from '@angular/material/sort';
import { ThemeService } from '@wm-libs/core';
import { Subscription, map } from 'rxjs';
import { CutStringPipe } from '@wm-libs/core';
import { TranslateModule } from '@ngx-translate/core';
import { CopyLoaderComponent } from '@wm-libs/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { NgIf, NgFor, AsyncPipe, UpperCasePipe, NgClass } from '@angular/common';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ModifiedAccessTokenListItem } from '../../interfaces/access-token.interface';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SELECT_CONFIG, MatSelectConfig } from '@angular/material/select';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.html',
  styleUrls: ['./data-table.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatTableModule,
    MatSlideToggleModule,
    MatSortModule,
    MatButtonModule,
    NgFor,
    MatTooltipModule,
    CopyLoaderComponent,
    MatPaginatorModule,
    AsyncPipe,
    TranslateModule,
    UpperCasePipe,
    CutStringPipe,
    NgClass,
  ],
  viewProviders: [
    {
      provide: MAT_SELECT_CONFIG,
      useValue: {
        overlayPanelClass: 'wm-paginator-select-panelClass',
      } as MatSelectConfig,
    },
  ],
})
export class DataTableComponent {
  @Input() title!: string;
  @Input() sorting = false;
  @Input() pagination = true;

  @Input() dataSource: unknown[] = [];
  @Input() displayedColumns: string[] = [];
  @Input() countData = 0;
  @Input() pageIndex = 0;
  @Input() count = 10;
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() sortingChanged = new EventEmitter<Sort>();

  // accesToken events
  @Output() toggleAccessTokenStatus = new EventEmitter<{ event: MatSlideToggleChange; element: ModifiedAccessTokenListItem }>();
  @Output() removeAccessToken = new EventEmitter<number>();
  @Output() editAccessTokenPermissions = new EventEmitter<ModifiedAccessTokenListItem>();

  @Output() cancelPayout = new EventEmitter<number>();

  isDarkMode$!: boolean;
  themeSubscription: Subscription;
  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  constructor(private themeService: ThemeService, private breakpointObserver: BreakpointObserver) {
    this.themeSubscription = this.themeService.isDarkMode$.subscribe((isDarkMode) => {
      this.isDarkMode$ = isDarkMode;
    });
  }

  sortData(sort: Sort) {
    if (this.sorting) {
      this.sortingChanged.emit(sort);
    }
  }

  sendToggleAccessTokenStatusEvent(event: MatSlideToggleChange, element: ModifiedAccessTokenListItem) {
    this.toggleAccessTokenStatus.emit({ event, element });
  }

  sendRemoveAccessTokenEvent(id: number) {
    this.removeAccessToken.emit(id);
  }

  sendEditAccessTokenPermissionsEvent(element: ModifiedAccessTokenListItem) {
    this.editAccessTokenPermissions.emit(element);
  }

  cancelPayoutHandle(id: number) {
    this.cancelPayout.emit(id);
  }
}
